import { useLocation } from "react-router-dom";
import { useBackendProps } from "@/react/providers";
import type { LocationState } from "@/react/routes/Main/RootRoute";

export const useSitePageMetadata = () => {
  const location = useLocation<LocationState>();
  const { pages_app_page: sitePage } = useBackendProps();

  const isSitePageRoute = Boolean(
    sitePage &&
      (location.pathname === `/${sitePage.slug}` ||
        location.pathname === `/${sitePage.slug}/`),
  );

  return {
    isSitePageRoute,
    sitePageId: sitePage?.id,
    sitePageSlug: sitePage?.slug,
  };
};
